// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Bi5a","question":"Question_question__29dcV","description":"Question_description__QmuLb"};